export default __webpack_public_path__ + "assets/cel-component.bed1fad3.svg";